import React from "react";

export default function CustomerMaintenanceComponent(props) {
  return (
    <div data-testid="customerMaintenanceComponent-testid">
      <h3 style={{ textAlign: "center" }}>{props?(props.response):"System is under maintenance.Please try again later!!"}</h3>
    </div>
  );
}
